import React, { Fragment, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import {
  StudentTextField,
  StudentGradeField,
  SecretCodeField,
  StudentGroupField
} from '../StudentDetailsForm/StudentDetailsFields';

export interface StudentDetailsEditProps {
  classes: any;
}

export const StudentDetailsEdit = ({ classes }: StudentDetailsEditProps): ReactElement => {
  const { t } = useTranslation('StudentDetailsEdit');

  return (
    <Fragment>
      <Grid item xs={12} sm={12}>
        <StudentTextField classes={classes} t={t} label="First Name" name="firstName" />
        <StudentTextField classes={classes} t={t} label="Last Name" name="lastName" />
        <StudentTextField classes={classes} t={t} label="Username" name="username" />
        <StudentTextField classes={classes} t={t} label="Email Address" name="email" />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <StudentGradeField classes={classes} t={t} label="Grade" name="gradeLevel" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <StudentGroupField classes={classes} t={t} label="Group" name="group" />
          </Grid>
        </Grid>
        <SecretCodeField label="Secret Code" name="secretCode" />
      </Grid>
    </Fragment>
  );
};
